import type { SpecSourceResult } from '../../api/client';

interface SpecUrlListProps {
  urls: SpecSourceResult[];
}

export function SpecUrlList({ urls }: SpecUrlListProps) {
  if (urls.length === 0) {
    return <p className="text-sm text-gray-400 italic">No spec URLs found yet.</p>;
  }

  return (
    <div className="space-y-2">
      {urls.map((u, idx) => (
        <div key={idx} className="flex items-center justify-between p-2.5 border rounded-lg bg-white hover:bg-gray-50">
          <div className="flex-1 min-w-0">
            <a
              href={u.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-primary-600 hover:underline truncate block"
            >
              {u.title || u.url}
            </a>
            <div className="flex items-center gap-2 mt-0.5">
              <span className="text-xs text-gray-500 capitalize">{u.source.replace(/_/g, ' ')}</span>
            </div>
          </div>
          <div className="ml-4 flex-shrink-0">
            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${
              u.confidence >= 0.8
                ? 'bg-green-100 text-green-700'
                : u.confidence >= 0.5
                  ? 'bg-yellow-100 text-yellow-700'
                  : 'bg-red-100 text-red-700'
            }`}>
              {Math.round(u.confidence * 100)}%
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
